module.exports = __webpack_public_path__ + "img/medium-plan-icon.5e83bf7e.svg";